import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=66499547&scoped=true&"
import script from "./alert.vue?vue&type=script&lang=ts&"
export * from "./alert.vue?vue&type=script&lang=ts&"
import style0 from "./alert.vue?vue&type=style&index=0&id=66499547&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66499547",
  null
  
)

component.options.__file = "alert.vue"
export default component.exports